import React, { useRef } from 'react';
import ReactDatePicker, {
  ReactDatePickerCustomHeaderProps,
} from 'react-datepicker';
import classNames from 'classnames';
import Icon from '../Icon';
import { formatDate } from './helpers';

export interface DatePickerProps {
  id?: string;
  className?: string;
  value?: Date | null;
  minDate?: Date;
  maxDate?: Date;
  onChange: (date: Date) => void;
  inputClassName?: string;
  placeholderText?: string;
}

interface DatePickerInputProps {
  onClick: () => void;
  className?: string;
}

const DatePickerHeader: React.FC<ReactDatePickerCustomHeaderProps> = ({
  date,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
}) => (
  <div className="ui-date-picker-header">
    <button
      aria-label="Previous month"
      className="ui-date-picker-navigation ui-date-picker-navigation--prev"
      type="button"
      onClick={decreaseMonth}
      disabled={prevMonthButtonDisabled}
    >
      <Icon name="chevron-left" size="xx-small" />
    </button>
    <div className="ui-date-picker-month-container">{formatDate(date)}</div>
    <button
      aria-label="Next month"
      className="ui-date-picker-navigation
        ui-date-picker-navigation--next"
      type="button"
      onClick={increaseMonth}
      disabled={nextMonthButtonDisabled}
    >
      <Icon name="chevron-right" size="xx-small" />
    </button>
  </div>
);

const DatePickerInput = React.forwardRef<
  HTMLInputElement,
  DatePickerInputProps
>(({ onClick, className, ...props }, ref) => {
  const inputClasses = classNames('ui-date-picker-input', className);

  return (
    // eslint-disable-next-line
    <div className="ui-date-picker-input-wrap" onClick={onClick}>
      <input ref={ref} type="text" className={inputClasses} {...props} />
      <Icon size="xx-small" name="calendar-simple" />
    </div>
  );
});

const DatePicker: React.FC<DatePickerProps> = (props) => {
  const ref = useRef(null);
  const { value, onChange, inputClassName, ...restProps } = props;
  const onKeyDown = (e: React.KeyboardEvent) => {
    // @ts-ignore
    if (e.key === 'Tab' && ref && ref.current?.setOpen) {
      // @ts-ignore
      ref.current.setOpen(false);
    }
  };

  return (
    // @ts-ignore
    <ReactDatePicker
      ref={ref}
      selected={value}
      onChange={onChange}
      className={inputClassName}
      useWeekdaysShort
      customInput={React.createElement(DatePickerInput)}
      renderCustomHeader={DatePickerHeader}
      onKeyDown={onKeyDown}
      {...restProps}
    />
  );
};

export default DatePicker;
